export const VIDEOS = [
  {
    url: 'https://www.youtube.com/watch?v=yP-mITD_Y4Y',
    urlEmbed: 'https://www.youtube.com/embed/yP-mITD_Y4Y?si=TDMmLbFTuKfgAWuO',
    thumb: 'https://img.youtube.com/vi/yP-mITD_Y4Y/maxresdefault.jpg',
    title: 'Alex Royal',
    description: 'Head of Influence в Royal Partners — как реально устроен инфлюенс-рынок в 2026 году.',
    description2: 'Инфлюенс-трафик в аффилке больше не работает по старой схеме. Рынок перегрет, стримеры выгорают, алгоритмы стали жестче. Александр разбирает офлайн-казино, микро-инфлюенсеров и экономику доверия. Латам vs СНГ, почему Бразилия взорвала цены на стримеров, и где в 2026 году ещё можно забирать бесплатный трафик.'
  },
  {
    url: 'https://www.youtube.com/watch?v=E1XTG-js8Z4',
    urlEmbed: 'https://www.youtube.com/embed/E1XTG-js8Z4?si=dLt_UFlEEDTMZVHa',
    thumb: 'https://img.youtube.com/vi/E1XTG-js8Z4/maxresdefault.jpg',
    title: 'Леван',
    description: 'BDO AffVibe — на стыке партнёрских сетей, веб-мастеров и рекламодателей.',
    description2: 'В арбитраже решают не только цифры — решают люди и связи. Леван рассказывает как реально делаются сделки через доверие и конференции, почему качество базы важнее объёма, как интроверту заводить контакты и где искать веб-мастеров в 2026 когда старые методы уже не работают.'
  },
  {
    url: 'https://www.youtube.com/watch?v=cbN7KgtUVQQ',
    urlEmbed: 'https://www.youtube.com/embed/cbN7KgtUVQQ?si=RgitzTV3yqE5QyxJ',
    thumb: 'https://img.youtube.com/vi/cbN7KgtUVQQ/maxresdefault.jpg',
    title: 'Евгений Носырев',
    description: 'CEO ZM apps — от заводов в Ижевске до высоконагруженного сервиса аренды мобильных приложений.',
    description2: 'Модерация жёстче, баны быстрее, классические Android-прилы теряют эффективность. Евгений рассказывает как ZM apps вышел в плюс за 4 месяца, почему большие объёмы = быстрые баны, что реально работает в PWA и iOS в 2026 — и как строить сервис где репутация важнее денег.'
  },
  {
    url: 'https://www.youtube.com/watch?v=cnwOxtv5ai8',
    urlEmbed: 'https://www.youtube.com/embed/cnwOxtv5ai8?si=3jXLTLO1DAqdK6fC',
    thumb: 'https://img.youtube.com/vi/cnwOxtv5ai8/maxresdefault.jpg',
    title: 'Ян К',
    description: 'CEO команды RIK — от минусовых заливов в Facebook до прибыльного бизнеса с десятком байеров.',
    description2: 'Арбитраж с 2018 года — это не одна история успеха, а череда ошибок, кассовых разрывов и связок которые уходят в минус. Ян честно рассказывает как менялся рынок, почему СНГ сужается, что делать когда рекламодатели кидают — и как построить команду которая работает без твоего постоянного участия.'
  },
  {
    url: 'https://www.youtube.com/watch?v=gVwDfHNqcIg',
    urlEmbed: 'https://www.youtube.com/embed/gVwDfHNqcIg?si=26Fla_1AU3Ma38YH',
    thumb: 'https://img.youtube.com/vi/gVwDfHNqcIg/maxresdefault.jpg',
    title: 'Алексей Громовиков',
    description: 'Основатель TSL Agency — от первого оффера до сети из 1600 вебмастеров.',
    description2: 'Партнёрки не умирают — они меняются. Алексей прошёл путь от первых сливов и команды из друзей до ребрендинга и агентства, которому доверяют. В выпуске — как строить связи без токсичности, почему KPI убивает мотивацию, где чаще всего кидают на выплаты и зачем арбитражнику выходить на сцену.'
  },
  {
    url: 'https://www.youtube.com/watch?v=wS7IR8F7-fg',
    urlEmbed: 'https://www.youtube.com/embed/wS7IR8F7-fg?si=845f61jkZUK4jjiJ',
    thumb: 'https://img.youtube.com/vi/wS7IR8F7-fg/maxresdefault.jpg',
    title: 'Денис Denzil',
    description: 'От спорта до Head of Affiliate в финансах — путь Дениса в арбитраже',
    description2: 'Путь от трафика и первых инвестиций до управления крупными командами. Как спортивная дисциплина влияет на работу, что формирует сильную команду и почему личный бренд становится точкой доверия. В фокусе — тренды 2025 года, ИИ в маркетинге, нестандартные источники трафика и внутренняя кухня финкоманд.'
  },
  {
    url: 'https://www.youtube.com/watch?v=8kkZVaFbkeo',
    urlEmbed: 'https://www.youtube.com/embed/8kkZVaFbkeo',
    thumb: 'https://img.youtube.com/vi/8kkZVaFbkeo/maxresdefault.jpg',
    title: 'Рафаэль Габитов',
    description: '17 лет в арбитраже: Diasp, Indigo, FBTool и другие истории успеха',
    description2: 'Рафаэль Габитов — 17 лет в арбитраже, путь от первых сайтов до Diasp, FBTool, Multilogin и Indigo. В этом выпуске — история становления, запуск продуктов, риски медийности, культура безопасности, покер и выгорание. И главное — почему он до сих пор лично общается с каждым клиентом.'
  },
  {
    url: 'https://www.youtube.com/watch?v=YShlrc__zWU',
    urlEmbed: 'https://www.youtube.com/embed/YShlrc__zWU?si=VhPbrbhb1nQgVyqP',
    thumb: 'https://img.youtube.com/vi/YShlrc__zWU/maxresdefault.jpg',
    title: 'Александр Флинт',
    description: 'О SEO в high-risk нишах, рынке SEO-трафика в 2025 году и команде будущего',
    description2: 'Александр Флинт — SEO-специалист с 2008 года, эксперт в iGaming и high-risk SEO, основатель агентства &Flint. В подкасте делится опытом построения команды, продвижения в «серых» нишах, работы с брендами и восстановления после апдейтов. Обсуждает рынок в 2025 году, провалы, текучку, автоматизацию и настоящую цену быстрого успеха.'
  },
  {
    url: 'https://www.youtube.com/watch?v=RR-GZ4pXnFs',
    urlEmbed: 'https://www.youtube.com/embed/RR-GZ4pXnFs?si=Xc38A0cjENVIJ-o0',
    thumb: 'https://img.youtube.com/vi/RR-GZ4pXnFs/maxresdefault.jpg',
    title: 'Тони Banzai',
    description: 'Путь от охраны до международного бизнеса | Арбитраж, маркетинг, Китай',
    description2: 'Тони Banzai — CEO партнёрской программы Banzai Partners, делится практическим опытом: как выстроить бизнес в Китае, собрать сильную команду, масштабировать трафик без слива бюджета и выжить в хаосе рынка гемблы.'
  },
  {
    url: 'https://youtu.be/lkh_S8iTZJ0?si=3yOv6oqQHTyPFeWT',
    urlEmbed: 'https://www.youtube.com/embed/lkh_S8iTZJ0?si=3yOv6oqQHTyPFeWT',
    thumb: 'https://img.youtube.com/vi/lkh_S8iTZJ0/maxresdefault.jpg',
    title: 'Стас Коробка',
    description: 'Арбитраж, Let It Cash, плюсовой медиабаинг',
    description2: 'Стас Коробка, CEO Let It Cash, делится своим путём в арбитраже: от первых шагов до управления одной из заметных команд на рынке. Обсуждаем партнёрки, трафик, медийность и реальные кейсы из жизни арбитражника. Как выстраивать процессы, не сливать в минус и оставаться в игре?'
  },
  {
    url: 'https://youtu.be/hBpJX5tu0wU?si=iMTiWYpncLbDRnAW',
    urlEmbed: 'https://www.youtube.com/embed/hBpJX5tu0wU?si=Z67emvEfUugaKCJe',
    thumb: 'https://img.youtube.com/vi/hBpJX5tu0wU/maxresdefault.jpg',
    title: 'Хозяин Казино',
    description: 'Оффлайн против онлайна, стриминг и секреты игорного бизнеса.',
    description2: 'Гость поделится опытом работы в казино и перехода от оффлайн бизнеса к онлайн-стримингу. Как устроен бизнес азартных игр и какие секреты существуют в этой индустрии?'
  },
  // {
  //   url: 'https://youtu.be/WXbD0X2oR7E?si=jV2vpAELL6uCU5Xv',
  //   urlEmbed: 'https://www.youtube.com/embed/WXbD0X2oR7E?si=jV2vpAELL6uCU5Xv',
  //   thumb: 'https://img.youtube.com/vi/WXbD0X2oR7E/maxresdefault.jpg',
  //   title: 'Игорь Горбатов',
  //   description: 'Путь в арбитраж, Конференции, Холдинг Marlerino Group',
  //   description2: 'Игорь Горбатов расскажет о своем пути в арбитраж, успехах в построении холдинга и участии в международных конференциях. Какие стратегии и подходы помогут вам добиться успеха в этом бизнесе?'
  // },
  {
    url: 'https://youtu.be/IN_WD6bRy2k?si=v_6kL8mFKufjzLmY',
    urlEmbed: 'https://www.youtube.com/embed/IN_WD6bRy2k?si=4jRgN-FWvRZw6tMj',
    localThumb: '/thumbs/yar-thumb.jpg',
    title: 'Ярослав Бабич',
    description: 'Опыт спикера на SIGMA, управление холдингом, арбитраж и секреты медиабаинга',
    description2: 'Ярослав Бабич — эксперт по медиабаингу и арбитражу. В этом выпуске расскажет, как эффективно управлять бизнесом и развивать арбитраж трафика.'
  },
  {
    url: 'https://youtu.be/rDg34MGurlQ?si=WBqbz-2TLLafr0S8',
    urlEmbed: 'https://www.youtube.com/embed/rDg34MGurlQ?si=WBqbz-2TLLafr0S8',
    thumb: 'https://img.youtube.com/vi/rDg34MGurlQ/maxresdefault.jpg',
    title: 'Seva Baller',
    description: 'Stream Summit, B2B инфлюенс и Стратегии в маркетинге',
    description2: 'Seva Baller делится секретами успешного участия в Stream Summit, а также раскрывает особенности работы с B2B инфлюенсерами и маркетинговыми стратегиями.'
  },
  {
    url: 'https://youtu.be/dcHFfB3RDDQ?si=avpZhWG0BUR8bZcg',
    urlEmbed: 'https://www.youtube.com/embed/dcHFfB3RDDQ?si=avpZhWG0BUR8bZcg',
    thumb: 'https://img.youtube.com/vi/dcHFfB3RDDQ/maxresdefault.jpg',
    title: 'Роман Мануйлов',
    description: 'Как Управлять Холдингом и Организовать Свою Конференцию',
    description2: 'Роман Мануйлов расскажет, как эффективно управлять холдингом, а также даст советы по организации успешных бизнес-конференций.'
  },
  {
    url: 'https://youtu.be/PAd7neKL_tI?si=ZQ-cv07Fa0gnyxaR',
    urlEmbed: 'https://www.youtube.com/embed/PAd7neKL_tI?si=ZQ-cv07Fa0gnyxaR',
    thumb: 'https://img.youtube.com/vi/PAd7neKL_tI/maxresdefault.jpg',
    title: 'Сергей TEMZA',
    description: 'Путь в гемблинг, стримы, сверхдоходы',
    description2: 'Сергей TEMZA делится опытом работы в гемблинге и стриминге, а также расскажет о секретах получения сверхдоходов в этой индустрии.'
  },
  {
    url: 'https://youtu.be/CD670oUAQkE?si=MHf-CAXVpx4lVIYt',
    urlEmbed: 'https://www.youtube.com/embed/CD670oUAQkE?si=MHf-CAXVpx4lVIYt',
    thumb: 'https://img.youtube.com/vi/CD670oUAQkE/maxresdefault.jpg',
    title: 'Иванов',
    description: 'Как стать самым популярным CPA инфлюенсером?',
    description2: 'Как выйти на уровень популярных CPA инфлюенсеров? Иванов поделится своим опытом и секретами успеха.'
  },
  {
    url: 'https://youtu.be/ox0bA6GBfpg?si=tOD-DIorfo5Kjyxx',
    urlEmbed: 'https://www.youtube.com/embed/ox0bA6GBfpg?si=tOD-DIorfo5Kjyxx',
    thumb: 'https://img.youtube.com/vi/ox0bA6GBfpg/maxresdefault.jpg',
    title: 'Додепов',
    description: 'Оффлайн стримы и карьера',
    description2: 'Додепов расскажет о своем пути в оффлайн стриминг и о том, как можно построить успешную карьеру в этой области.'
  },
  {
    url: 'https://youtu.be/ZJ6v4Ra-DlM?si=Ck7UsYrlX9nuMH1y',
    urlEmbed: 'https://www.youtube.com/embed/ZJ6v4Ra-DlM?si=Ck7UsYrlX9nuMH1y',
    thumb: 'https://img.youtube.com/vi/ZJ6v4Ra-DlM/maxresdefault.jpg',
    title: 'Михаил Дубовой',
    description: 'От офлайн-бизнеса до успешного арбитража трафика',
    description2: 'Михаил расскажет, как перейти от традиционного бизнеса к арбитражу трафика и достигнуть успеха в этой сфере.'
  },
  {
    url: 'https://youtu.be/_x9ahsNqHko?si=zGEmUZP0AHsRGX80',
    urlEmbed: 'https://www.youtube.com/embed/_x9ahsNqHko?si=zGEmUZP0AHsRGX80',
    thumb: 'https://img.youtube.com/vi/_x9ahsNqHko/maxresdefault.jpg',
    title: 'Лорд Трепутин',
    description: 'Стримы, казино, бизнес, успехи',
    description2: 'Лорд Трепутин поделится секретами успешных стримов, а также расскажет о своей работе в бизнесе казино и его успехах.'
  },
  {
    url: 'https://youtu.be/eiHxlVyGs9U?si=bxqYM9WVhoKmHSbm',
    urlEmbed: 'https://www.youtube.com/embed/eiHxlVyGs9U?si=bxqYM9WVhoKmHSbm',
    thumb: 'https://img.youtube.com/vi/eiHxlVyGs9U/maxresdefault.jpg',
    title: 'Денис Дзюбенко',
    description: 'Правда о конференции SiGMA',
    description2: 'Денис расскажет, что стоит за одной из самых известных конференций SiGMA и как извлечь максимальную выгоду от таких мероприятий.'
  },
  {
    url: 'https://youtu.be/3-LThlg_upA?si=BrpzBR7C2P5cPyss',
    urlEmbed: 'https://www.youtube.com/embed/3-LThlg_upA?si=x1BiD1TkF4tWnqoj',
    thumb: 'https://img.youtube.com/vi/3-LThlg_upA/maxresdefault.jpg',
    title: 'Артем Прокофьев',
    description: 'Gambling Pro, проблемы разработки, УБТ',
    description2: 'Артем расскажет о проблемах разработки в гемблинге и о важности пользовательского тестирования в этой сфере.'
  },
  {
    url: 'https://youtu.be/uuPBjCYFZF8?si=veqhBL2Sdry92zG6',
    urlEmbed: 'https://www.youtube.com/embed/uuPBjCYFZF8?si=dI_WTImtF-U0w0pw',
    thumb: 'https://img.youtube.com/vi/uuPBjCYFZF8/maxresdefault.jpg',
    title: 'Александр Дужников',
    description: 'BROCONF, арбитраж, бизнес в США.',
    description2: 'Александр расскажет о своем опыте создания и проведения конференций, а также о бизнесе в США и арбитраже трафика.'
  },
  {
    url: 'https://www.youtube.com/embed/pDqDNIdAmwc',
    urlEmbed: 'https://www.youtube.com/embed/pDqDNIdAmwc',
    thumb: 'https://img.youtube.com/vi/pDqDNIdAmwc/maxresdefault.jpg',
    title: 'Наиль Байков',
    description: 'Какие проблемы часто возникают на конференциях и среди спикеров?',
    description2: 'Наиль Байков расскажет о сложностях, с которыми сталкиваются спикеры на конференциях, и как их решать.'
  },
  {
    url: 'https://www.youtube.com/watch?v=1auECQloaz4',
    urlEmbed: 'https://www.youtube.com/embed/1auECQloaz4?si=-vh5wPzOBOuaDaNP',
    thumb: 'https://img.youtube.com/vi/1auECQloaz4/maxresdefault.jpg',
    title: 'VASKOV',
    description: 'Гость нашего выпуска -  Стример Васьков VASKOV. Первый народный!',
    description2: 'VASKOV — один из самых популярных стримеров, который поделится своим опытом, путём к успеху и секретами популярности.'
  },
  {
    url: 'https://www.youtube.com/watch?v=V9Mg1fDamS4',
    urlEmbed: 'https://www.youtube.com/embed/V9Mg1fDamS4?si=Db3Svu0xo7oyDFDU',
    thumb: 'https://img.youtube.com/vi/V9Mg1fDamS4/maxresdefault.jpg',
    title: 'Саша Уснул',
    description: 'Как партнерки и CPA-сетки продвигают себя, как развивается Youtube-направление и в целом медийка',
    description2: 'Саша Уснул расскажет о том, как партнёрки и CPA-сетки развивают своё присутствие в интернете, и о трендах в медийных платформах.'
  },
  {
    url: 'https://www.youtube.com/watch?v=_pofQddb0lw',
    urlEmbed: 'https://www.youtube.com/embed/_pofQddb0lw?si=84eBMUf8pDQyo6jW',
    thumb: 'https://img.youtube.com/vi/_pofQddb0lw/maxresdefault.jpg',
    title: 'Belatra Games',
    description: 'Кто и как создаёт ваши любимые слоты? Узнали всё, об играх в казино.',
    description2: 'Представители Belatra Games расскажут, как создаются самые популярные слоты и игры для казино, а также поделятся инсайтами из индустрии.'
  },
  {
    url: 'https://www.youtube.com/watch?v=vmNxc7clTtI',
    urlEmbed: 'https://www.youtube.com/embed/vmNxc7clTtI?si=QsiLSpTB0RFReM_F',
    thumb: 'https://img.youtube.com/vi/vmNxc7clTtI/maxresdefault.jpg',
    title: 'STRIJ',
    description: 'SEO и голод кадров, флаг гемблинга, профсоюз аффилейтов.',
    description2: 'STRIJ расскажет о трудностях поиска квалифицированных кадров в гемблинге и как решать проблемы SEO в этой области.'
  },
  {
    url: 'https://www.youtube.com/watch?v=lDSSFLm0hQ0',
    urlEmbed: 'https://www.youtube.com/embed/lDSSFLm0hQ0?si=rpZ_KQP18zioGxZ2',
    thumb: 'https://img.youtube.com/vi/lDSSFLm0hQ0/maxresdefault.jpg',
    title: 'Эрдэм, CEO Royal Partners',
    description: 'Человек, который подписал LuxuryGirl на стриминг, главный советчик MELLSTROY, а также друг Егора Крида по переписке.',
    description2: 'Эрдэм поделится своим опытом в роли главного советника и влияния на важнейших влиятельных личностей.'
  }
]

export const FOOTER_LEFT_ICONS = [
  {
    url: 'https://www.youtube.com/@troeproroi',
    icon: 'youtube'
  },
  {
    url: 'https://www.instagram.com/troe_pro_roi/',
    icon: 'instagram'
  },
  {
    url: 'https://t.me/troe_pro_roi',
    icon: 'telegram'
  }
]

export const FOOTER_RIGHT_ICONS = [
  {
    url: 'https://t.me/greatagaincpa',
    icon: 'telegram'
  },
  {
    url: 'mailto:troeproroi@gmail.com',
    icon: 'mail'
  }
]
